import React from "react";
import AreaBarChart from "./area-bar-chart";
import AreaProgressChart from "./area-progress-chart";
import ImageSlider from "../../image-slider/image-slider";

const AreaCharts = () => {
  return (
    <section className="content-area-charts">
      <AreaBarChart />
      <ImageSlider />
      {/*<AreaProgressChart />*/}
    </section>
  );
};

export default AreaCharts;
